import React from "react";
import { PlayIcon } from "../ManageReports";
import { IconButton } from "@mui/material";
import { Col, Label } from "reactstrap";
import { setAmplitudeEvent } from "amplitude/amplitude";

const DataExportHeader = ({
  isFromReportSchedules = false,
  reportNameValue,
  label = {},
}) => {
  const windowFeatures =
    "resizable=1,status=yes,scrollbars=0,toolbar=0,titlebar=0,location=no,width=800,height=650,dialog=1,minimizable=1";
  const windowName = "EnsembleVideoWindow";
  const videoUrl =
    "https://vimeo.com/718036571/e98f3697e9?share=copy&childpage=true";
  return (
    <>
      <Col sm={{ size: 6 }}>
        <Label className="dataexportmainheaderlbl">
          {isFromReportSchedules
            ? "Report Schedule for " + reportNameValue
            : label["DataExport.Text"] !== undefined &&
              Object.keys(label["DataExport.Text"]).length !== 0
            ? label["DataExport.Text"]
            : "Data Export"}
        </Label>
      </Col>
      <Col sm={{ size: 6 }} style={{ textAlign: "right" }}>
        <IconButton
          id="dataExportHeaderIconButton"
          style={{ textAlign: "right", width: "25px", height: "25px" }}
          onClick={() => {
            window.open(videoUrl, windowName, windowFeatures);
            setAmplitudeEvent('Help Videos', {
              "Source": "Icon",
              "Video Name": "Data Exports Report",
              "Page URL": '/React/Home.aspx?Page=ManageReports#/ManageReports/DataExport'})

          }}
        >
          <PlayIcon style={{ width: "25px", height: "25px" }} />
        </IconButton>{" "}
      </Col>
    </>
  );
};

export default DataExportHeader;
